import i18n from "i18next";
import { ChangeDateFormat } from "../../Common/Helpers/ChangeDateFormat";
import { ToCustomDecimal } from "../../AppSystem/Helpers/ToCustomDecimal";

class ResponseEconomicReportModel {
    constructor({
                    amount = '',
                    model = '',
                    orgName = '',
                    orgType = '',
                    costBearerName = '',
                    costPlace = '',
                    createdAt = '',
                    createdByName = '',
                    reimbursementDate = '',
                    type = '',
                    subtype = '',
                    details = '',
                    relatedReimbursementModel = '',
                    relatedReimbursementExtraInfo = '',
                    honorariumUserName = '',
                } = {}) {
        this.amount = amount;
        this.model = model;
        this.orgName = orgName;
        this.orgType = orgType;
        this.costBearerName = costBearerName;
        this.costPlace = costPlace;
        this.createdAt = createdAt;
        this.createdByName = createdByName;
        this.reimbursementDate = reimbursementDate;
        this.type = type;
        this.subtype = subtype;
        this.relatedReimbursementModel = relatedReimbursementModel;
        this.relatedReimbursementExtraInfo = relatedReimbursementExtraInfo;
        this.details = details;
        this.honorariumUserName = honorariumUserName;
    }

    static getAttributes(filter = null, validationSchema = null) {
        const userName = i18n.t('modelLabel.name');
        const orgName = i18n.t('modelLabel.org');
        const date = i18n.t('modelLabel.date');
        const status = i18n.t('modelLabel.status');
        const createdAt = 'Transaktionsdatum';
        const amount = i18n.t('modelLabel.amount');
        const reimbursementDate = i18n.t('modelLabel.dateReimbursement');
        const typeLabel = i18n.t('internalTransaction.type');
        const subtypeLabel = i18n.t('internalTransaction.subtype');
        const relatedReimbursementModelTitle = 'Subtyp';
        const relatedReimbursementExtraInfoTitle = 'Extra info';
        const detailsTitle = i18n.t('economicReport.details');

        const attributes = {
            amount :{
                'label': amount,
                'sortable': true,
                'sortField': 'amount',
                'insideClass' : (item)=> item.amount >= 0 ? 'text-green text-end fixed-width' : 'text-red text-end fixed-width',
                'value': (item) => item.amount ? ToCustomDecimal(item.amount) +' kr' : "",
                'type': 'number',
                'thClass': 'ps-5'
            },
            model :{
                'label': 'Transaktionstyp',
                'sortable': true,
                'sortField': 'model',
                'value': (item) => item.model === 'Förrättning' ? i18n.t('reimbursement.reportProcessing') : item.model === 'Arvode' ? i18n.t('honorarium.honorarium') : item.model === 'Betala' ? i18n.t('payReceive.pay') : item.model === 'Intern transaktion' ? i18n.t('internalTransaction.internalTransaction') : item.model === 'Faktura betald' ? i18n.t('invoice.invoiceEconomicReport') : item.model === 'Faktura' ? i18n.t('invoice.invoiceEconomicReport') : item.model || "",
                'type': 'selectMulti',
            },
            orgName :{
                'label': orgName,
                'sortable': true,
                'sortField': 'orgName',
                'value': (item) => item.orgName || "",
            },
            orgType :{
                'label': 'Organisationstyp',
                'sortable': true,
                'sortField': 'orgType',
                'value': (item) => item.orgType || "",
            },
            costBearerName :{
                'label': 'Aktivitetsområde',
                'sortable': true,
                'sortField': 'costBearerName',
                'value': (item) => (item.costBearerName === 'Styrelsemöte regionförbund') 
                   ? 'Styrelsemöte Regförb/Riksförb' 
                   : item.costBearerName || "",
                'type': 'selectMulti',
            },
            costPlace :{
                'label': 'KST',
                'sortable': true,
                'sortField': 'costPlace',
                'value': (item) => item.costPlace || "",
                'type': 'selectMulti',
            },
            createdAt :{
                'label': createdAt,
                'sortable': true,
                'sortField': 'createdAt',
                'value': (item) => item.createdAt ? ChangeDateFormat('date', item.createdAt) : "" || "",
                'type': 'dateTime',
            },
            reimbursementDate :{
                'label': reimbursementDate,
                'sortable': true,
                'sortField': 'reimbursementDate',
                'value': (item) => item.reimbursementDate ? ChangeDateFormat('date', item.reimbursementDate) : "" || "",
                'type': 'dateTime',
            },
            createdByName :{
                'label': 'Person',
                'sortable': true,
                'sortField': 'createdByName',
                'value': (item) => item.createdByName || "",
            },
            type :{
                'label': typeLabel,
                'sortable': false,
                'sortField': 'type',
                'value': (item) => item.type || "",
                'showInFilter': false,
                'thClass': 'text-start',
            },
            relatedReimbursementModel :{
                'label': relatedReimbursementModelTitle,
                'sortable': false,
                'showInFilter': false,
                'sortField': 'relatedReimbursementModel',
                'value': (item) => item.relatedReimbursementModel || item.subtype || "",
                 'thClass': 'text-start',
            },
            relatedReimbursementExtraInfo :{
                'label': relatedReimbursementExtraInfoTitle,
                'sortable': false,
                'showInFilter': false,
                'sortField': 'relatedReimbursementExtraInfo',
                'value': (item) => item.relatedReimbursementExtraInfo || "",
            },
            details: {
                'label': detailsTitle,
                'value': (item) => {
                    return item.model === "Intern transaktion"
                        ? item.message || ""
                        : item.details || "";
                },
                'type': 'text',
                'sortable': false,
                'showInFilter': false,
                'thClass': 'text-start',
            },
        }
        // Add filter options if provided
        return attributes;
    }
}

export default ResponseEconomicReportModel;